import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SearchBar from '../search/search-bar';
import { withStyles } from '@material-ui/core/styles';
import PenIcon from '@material-ui/icons/CreateOutlined';
import PhotoIcon from '@material-ui/icons/AddAPhotoOutlined';
import VideoIcon from '@material-ui/icons/VideocamOutlined';
import ContentIcon from '@material-ui/icons/ClassOutlined';
import ThumbUpIcon from '@material-ui/icons/ThumbUpOutlined';
import CommentIcon from '@material-ui/icons/ModeCommentOutlined';
import SendIcon from '@material-ui/icons/Send';
import Typography from '@material-ui/core/Typography';
import { ThemeColors } from '../../theme';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import FaceIcon from '@material-ui/icons/Face';
import moment from 'moment';
import Youtube from 'react-youtube';
import IconButton from '@material-ui/core/IconButton';
import { Button, RichtextEditor } from '../../components/';
import EmojiPicker from './emoji-picker';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import LinkedContentView from './linked-content-view';
import ContextMenuIcon from '@material-ui/icons/MoreHoriz';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import EmoteIcon from '@material-ui/icons/InsertEmoticon';

class SocialWallPost extends Component {

  constructor(props) {
    super(props);
    this.state = {
      commentSectionOpen: false,
      emoteDialogOpen: false,
      comment: '',
    };

    this.commenInputRef = null;
  }

  componentWillMount() {

  }

  extractVideoIdFromYoutubeUrl(url) {
    /*eslint-disable */
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length === 11) ? match[7] : false;
    /*eslint-enable */
  }

  formatDate = date => moment(date).format('DD.MM.YYYY hh:mm')

  handleOpenEmoteDialog = (event) => {
    this.setState({
      emoteDialogOpen: event.currentTarget,
    });
  }

  handleCloseEmoteDialog = () => {
    this.setState({
      emoteDialogOpen: false,
    });
  }

  handleInsertEmoji = (event, selection) => {
    this.setState({
      comment: `${this.state.comment}${selection.emoji}`,
      emoteDialogOpen: false,
    });
  }

  handleCommentSectionOpen = () => {
    this.setState({ commentSectionOpen: !this.state.commentSectionOpen }, () => {
      if (this.state.commentSectionOpen && this.commenInputRef) this.commenInputRef.focus();
    });
  }

  handleOpenContextMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleCreateResponse = (responseType, responseContent) => {
    const dto = {
      content: responseContent,
      responseType,
    };

    const data = {
      id: this.props.post.id,
      dto,
    };

    this.props.createResponse(data);

    if (responseType === 'Comment') {
      this.setState({ comment: '' });
    }
  }

  handleUpdatePost = () => {
    const post = this.props.post.asMutable();
    post.pinnedByAdmin = !post.pinnedByAdmin;
    this.props.updatePost(post.id, post);

    this.setState({
      anchorEl: null,
    });
  }

  renderUserAvatar(imageLink) {
    const avatarStyle = {
      marginRight: 10,
      fontSize: 30,
    };

    return imageLink
      ? (<Avatar style={avatarStyle} src={imageLink} size={40} />)
      : (<Avatar style={avatarStyle}><FaceIcon /></Avatar>);
  }


  renderCreator() {
    const { classes } = this.props;
    const { creator, dateOfCreation, groupIds } = this.props.post;
    const { creatorId, displayImage, displayName, type } = creator;

    return (
      <div className={classes.creatorContainer}>
        {this.renderUserAvatar(displayImage)}
        <div>
          <Typography className={classes.creatorNameStyle}>{displayName}</Typography>
          <Typography className={classes.dateStyle}>{this.formatDate(dateOfCreation)}</Typography>
        </div>
      </div>
    );
  }

  renderLinkedContent() {
    return (
      <LinkedContentView
        history={this.props.history}
        linkedContent={this.props.post.linkedContent}
      />
    );
  }

  renderVideo() {
    const link = this.props.post.videoLink;
    if (!link) return null;

    const youtubeVideoId = this.extractVideoIdFromYoutubeUrl(link);
    const opts = {
      // maxHeight: 400,
      // height: '301',
      width: '100%',
      playerVars: {
        showinfo: 0,
        rel: 0,
      },
    };

    return (
      <Youtube
        videoId={youtubeVideoId}
        opts={opts}
        onPlay={this.onPlayVideo}
      />
    );
  }

  renderImages() {
    const images = this.props.post.imageUrls;

    if (!images || images.length < 1) return null;

    const imageCountIsEven = images.length % 2 === 0;

    return images.map(
      (img, idx) => {
        const imageWidth = !imageCountIsEven && idx === images.length - 1
          ? '100%'
          : '50%';

        return (
          <img src={img} width={imageWidth} style={{ maxWidth: imageWidth, maxHeight: imageWidth }} />
        );
      });
  }

  renderContent() {
    const content = this.props.post.content;
    const { classes } = this.props;
    return <Typography className={classes.postContent}>{content}</Typography>;
  }

  checkPostAlreadyLiked = () => {
    const { responses } = this.props.post;
    if (!responses || responses.length < 1) return false;
    const likes = responses.filter(r =>
      r.responseType === 'Feedback' &&
      r.userId === this.props.user.id);
    return (likes.length >= 1);
  }

  renderMarkPostAsPinned = () => {
    const { roles, classes } = this.props;
    const adminRoles = roles.filter(r => r.roleName === 'SUPER-ADMIN' ||
      r.roleName === 'DIVISION-ADMIN');
    if (adminRoles.length < 1) return <div />;

    return (
      <div className={classes.iconContainerStyle}>
        <ContextMenuIcon className={classes.iconsStyle} onClick={this.handleOpenContextMenu} />
      </div>
    );
  }

  renderContextMenu() {
    const menuText = this.props.post.pinnedByAdmin
      ? 'Fixierung aufheben'
      : 'Oben auf der Seite fixieren';

    const contextMenuItems = [
      <MenuItem onClick={this.handleUpdatePost}>{menuText}</MenuItem>,
    ];

    return (
      <Menu
        id="context-menu"
        anchorEl={this.state.anchorEl}
        keepMounted
        open={this.state.anchorEl}
        onClose={() => this.setState({ anchorEl: null })}
      >
        {contextMenuItems}
      </Menu>
    );
  }

  renderResponseContainer() {
    const { classes } = this.props;

    const likebuttonStyle = this.checkPostAlreadyLiked()
      ? { color: ThemeColors.accent1Color }
      : {};

    return (
      <div className={classes.responseContainer}>
        <div
          className={classes.responseAction}
          onClick={() => this.handleCreateResponse('Feedback', '=D')}
        >
          <ThumbUpIcon style={likebuttonStyle} className={classes.responseIconStyle} />
          <Typography style={likebuttonStyle}>Gefällt mir </Typography>
        </div>
        <div
          onClick={this.handleCommentSectionOpen}
          className={classes.responseAction}
        >
          <CommentIcon className={classes.responseIconStyle} />
          <Typography>Kommentieren </Typography>
        </div>

      </div>

    );
  }

  renderCommentCount() {
    const { responses } = this.props.post;
    if (!responses || responses.length < 1) return null;
    const comments = responses.filter(r => r.responseType === 'Comment');
    if (comments.length < 1) return null;

    return (
      <Typography
        style={{ cursor: 'pointer' }}
        onClick={this.handleCommentSectionOpen}
      >{`${comments.length} Kommentare`}</Typography>
    );
  }

  renderLikeCount() {
    const { responses } = this.props.post;
    if (!responses || responses.length < 1) return null;
    const likes = responses.filter(r => r.responseType === 'Feedback');
    if (likes.length < 1) return <div />;

    return (
      <div style={{ display: 'flex' }}>
        <ThumbUpIcon style={{ color: ThemeColors.accent1Color, marginRight: 5 }} />
        <Typography>{`${likes.length}`}</Typography>
      </div>
    );
  }

  renderComment({ content, creator, dateOfCreation }) {
    const { creatorId, displayImage, displayName, type } = creator;
    const { classes } = this.props;

    return (
      <div className={classes.creatorContainer}>
        {this.renderUserAvatar(displayImage)}
        <div style={{ backgroundColor: '#F0F2F5', borderRadius: 5, padding: 10, width: '100%' }}>
          <Typography className={classes.creatorNameStyle}>{displayName}</Typography>
          <Typography className={classes.commentContent}>{content}</Typography>
        </div>
      </div>
    );
  }

  renderInputAdornmentForComments = () => {
    const submitButton = this.state.comment
    ? (
      <IconButton
        disabled={!this.state.comment}
        style={{ padding: 6, paddingLeft: 2 }}
        onClick={() => this.handleCreateResponse('Comment', this.state.comment)}
      >
        <SendIcon color="primary" />
      </IconButton>
    )
    : null;

    return (
      <InputAdornment position="end">
        <div style={{ display: 'flex' }}>
          <IconButton
            style={{ padding: 6, paddingRight: 2 }}
            onClick={this.handleOpenEmoteDialog}
          >
            <EmoteIcon />
          </IconButton>
          {submitButton}
        </div>
      </InputAdornment>
    );
  }

  renderCommentingTextField() {
    return (
      <Input
        onChange={e => this.setState({ comment: e.target.value })}
        inputRef={r => this.commenInputRef = r}
        value={this.state.comment}
        fullWidth
        onKeyPress={e => (e.key === 'Enter' && !e.shiftKey) && this.handleCreateResponse('Comment', this.state.comment)}
        style={{ padding: 5, margin: 10 }}
        multiline
        // onFocus={this.handleInputFocused}
        rows={this.state.comment ? 2 : 1}
        rowsMax={5}
        placeholder="Kommentieren ..."
        endAdornment={
          this.renderInputAdornmentForComments()
        }
      />
    );
  }

  renderComments() {
    if (!this.state.commentSectionOpen) return null;
    const { responses } = this.props.post;
    // if (!responses || responses.length < 1) return null;
    const comments = responses.filter(r => r.responseType === 'Comment');
    // if (comments.length < 1) return null;

    const commentBlocks = comments.map(c => this.renderComment(c));
    let commentsFiltered = commentBlocks;

    if (!this.state.showAllComments) {
      commentsFiltered = commentBlocks.slice(0, 5);
    }

    let showAllButton = null;

    if (!this.state.showAllComments && comments.length > 5) {
      showAllButton = (<Button
        label="Alle anzeigen"
        onClick={() => {
          commentsFiltered = commentBlocks;
          this.setState({ showAllComments: true });
        }}
      />);
    } else if (this.state.showAllComments && comments.length > 5) {
      showAllButton = (<Button
        label="Weniger anzeigen"
        onClick={() => {
          commentsFiltered = commentBlocks.slice(0, 5);
          this.setState({ showAllComments: false });
        }}
      />);
    }

    return (
      <div>
        <div style={{ display: 'flex' }}>
          {this.renderCommentingTextField()}
        </div>

        {commentsFiltered}
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 10 }}>
          {showAllButton}
        </div>
      </div>
    );
  }

  renderResponses() {
    const { classes } = this.props;
    return (
      <div>
        <div
          className={classes.responseContainer}
          style={{ borderBottom: 'lightgrey 1px solid', paddingBottom: 5 }}
        >
          {this.renderLikeCount()}
          {this.renderCommentCount()}
        </div>
        {this.renderComments()}
      </div>
    );
  }

  render() {
    const { classes } = this.props;

    return (
      // <div className="col-lg-10 col-md-12 col-sm-12">
      <div className={classes.postContainer}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {this.renderCreator()}
          {this.renderMarkPostAsPinned()}
        </div>
        {this.renderContent()}
        {this.renderLinkedContent()}
        {this.renderVideo()}
        {this.renderImages()}
        {this.renderResponses()}
        {this.renderResponseContainer()}
        {this.renderContextMenu()}
        <EmojiPicker
          onClose={this.handleCloseEmoteDialog}
          open={this.state.emoteDialogOpen}
          onEmojiSelected={this.handleInsertEmoji}
        />
      </div>
    );
  }
}

SocialWallPost.propTypes = {
};

const styles = theme => ({
  creatorNameStyle: {
    fontSize: 14,
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  commentContent: {
    whiteSpace: 'pre-wrap',
  },
  creatorContainer: {
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    margin: 10,
  },
  dateStyle: {
    fontSize: 10,
    color: 'grey',
  },
  postContent: {
    fontSize: 14,
    margin: 10,
    whiteSpace: 'pre-wrap',
  },
  postContainer: {
    borderColor: 'lightgrey',
    borderWidth: 1,
    borderStyle: 'solid',
    marginTop: 20,
  },
  responseContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: 10,
  },
  responseAction: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  responseIconStyle: {
    marginRight: 10,
  },
  iconsStyle: {
    height: 25,
    width: 25,
    margin: '2px 5px',
    color: theme.palette.primary.main,
  },
  iconContainerStyle: {
    cursor: 'pointer',
  },
});

export default withStyles(styles)(SocialWallPost);



// WEBPACK FOOTER //
// ./src/app/main/socialwall/socialwall-post.js